module.exports = "<div class=form-control> <div class=year style=float:left;width:100px></div> <span style=float:left> &nbsp;年 &nbsp;</span> <div class=month style=float:left;width:100px></div> <span style=float:left> &nbsp;月</span> </div>";


//////////////////
// WEBPACK FOOTER
// ./app/components/form/year-month-control/year-month-control.wx.html
// module id = 1965
// module chunks = 50